import { Recipe } from '../../api/Recipe';

const LEGACY_FAVORITES_KEY = 'favorites';
const AUTHOR_FAVORITES_CACHE_PREFIX = 'favorites:author:';
const LEGACY_REVIEWED_PREFIX = 'favorites:legacy-reviewed:';

const hasRecipeId = (value: unknown): value is Recipe =>
  !!value && typeof value === 'object' && !!(value as Recipe).id;

export const uniqueFavoriteRecipes = (recipes: Recipe[]): Recipe[] => {
  const seen = new Set<string>();

  return recipes.filter((recipe) => {
    if (!recipe?.id || seen.has(recipe.id)) {
      return false;
    }

    seen.add(recipe.id);
    return true;
  });
};

const getAuthorCacheKey = (authorId: number): string => `${AUTHOR_FAVORITES_CACHE_PREFIX}${authorId}`;
const getLegacyReviewedKey = (authorId: number): string => `${LEGACY_REVIEWED_PREFIX}${authorId}`;

export const parseFavoriteRecipes = (rawValue: string | null): Recipe[] => {
  if (!rawValue) {
    return [];
  }

  try {
    const parsed = JSON.parse(rawValue);
    if (!Array.isArray(parsed)) {
      return [];
    }

    return uniqueFavoriteRecipes(parsed.filter(hasRecipeId));
  } catch {
    return [];
  }
};

export const readAuthorFavoritesCache = (authorId: number): Recipe[] =>
  parseFavoriteRecipes(localStorage.getItem(getAuthorCacheKey(authorId)));

export const writeAuthorFavoritesCache = (authorId: number, recipes: Recipe[]): void => {
  localStorage.setItem(
    getAuthorCacheKey(authorId),
    JSON.stringify(uniqueFavoriteRecipes(recipes))
  );
};

export const readLegacyFavoritesCache = (): Recipe[] =>
  parseFavoriteRecipes(localStorage.getItem(LEGACY_FAVORITES_KEY));

export const hasReviewedLegacyFavorites = (authorId: number): boolean =>
  localStorage.getItem(getLegacyReviewedKey(authorId)) === 'true';

export const markLegacyFavoritesReviewed = (authorId: number): void => {
  localStorage.setItem(getLegacyReviewedKey(authorId), 'true');
};

export const removeLegacyFavoritesCache = (): void => {
  localStorage.removeItem(LEGACY_FAVORITES_KEY);
};
